// @flow
import performanceService from './performanceService';
import performanceActionKeys from './performanceActionKeys';
import type {
  GetContactMetricsByServiceProviderRequest,
  GetContactMetricsCategoryGroupsByServiceProviderRequest,
  GetCallLogByServiceProviderRequest,
  CustomerAttributesRequest,
} from './performanceService';

const getContactMetricsByServiceProvider = ({
  serviceProviderId,
  startTime,
  endTime,
}: GetContactMetricsByServiceProviderRequest): {|
  payload: {|
    data: {|endTime: Date, serviceProviderId: number, startTime: Date|},
    promise: any,
  |},
  type: string,
|} => ({
  type: performanceActionKeys.GET_CONTACT_METRICS_BY_SERVICE_PROVIDER,
  payload: {
    data: { serviceProviderId, startTime, endTime },
    promise: performanceService.getContactMetricsByServiceProvider({
      serviceProviderId,
      startTime,
      endTime,
    }),
  },
});

const getContactMetricsCategoryGroupsByServiceProvider = ({
  serviceProviderId,
  startTime,
  endTime,
}: GetContactMetricsCategoryGroupsByServiceProviderRequest): {|
  payload: {|
    data: {|endTime: Date, serviceProviderId: number, startTime: Date|},
    promise: any,
  |},
  type: string,
|} => ({
  type: performanceActionKeys.GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER,
  payload: {
    data: { serviceProviderId, startTime, endTime },
    promise: performanceService.getContactMetricsCategoryGroupsByServiceProvider({
      serviceProviderId,
      startTime,
      endTime,
    }),
  },
});

const getCallLogByServiceProvider = ({
  serviceProviderId,
  offset,
  numberOfEntries,
}: GetCallLogByServiceProviderRequest): {|
  payload: {|data: {|serviceProviderId: number|}, promise: any|},
  type: string,
|} => ({
  type: performanceActionKeys.GET_CALL_LOG_BY_SERVICE_PROVIDER,
  payload: {
    data: { serviceProviderId },
    promise: performanceService.getCallLogByServiceProvider({
      serviceProviderId,
      offset,
      numberOfEntries,
    }),
  },
});

const getCustomerAttributesByUuid = ({ serviceProviderId, uuid }: CustomerAttributesRequest): {|
  payload: {|
    data: {|serviceProviderId: number, uuid: string|},
    promise: any,
  |},
  type: string,
|} => ({
  type: performanceActionKeys.GET_CUSTOMER_ATTRIBUTES_BY_UUID,
  payload: {
    data: { serviceProviderId, uuid },
    promise: performanceService.getCustomerAttributesByUuid({
      serviceProviderId, uuid,
    }),
  },
});

export default {
  getContactMetricsByServiceProvider,
  getContactMetricsCategoryGroupsByServiceProvider,
  getCallLogByServiceProvider,
  getCustomerAttributesByUuid,
};



// WEBPACK FOOTER //
// ./src/modules/home/common/performanceActions.js